import { Component, ElementRef, EventEmitter, HostListener, Output, signal, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CanvasToolbarIconComponent } from '../../../icons/canvas-toolbar-icon.component';

export type CanvasSearchMode = 'global' | 'bbox';

@Component({
  selector: 'lib-canvas-search-tool',
  standalone: true,
  imports: [CommonModule, CanvasToolbarIconComponent],
  template: `
    <div class="cv-tb-split cv-tb-search">
      <button type="button" class="cv-tb__btn cv-tb-split__main" (click)="onMainClick()" title="Global search">
        <lib-canvas-toolbar-icon name="global-search"></lib-canvas-toolbar-icon>
      </button>
      <button
        type="button"
        class="cv-tb__btn cv-tb__btn--chevron-only"
        [class.cv-tb__btn--active]="isOpen()"
        (click)="toggleMenu($event)"
        title="Search options"
        [attr.aria-expanded]="isOpen()"
      >
        <lib-canvas-toolbar-icon name="chevron-down" [imgClass]="chevronImgClass"></lib-canvas-toolbar-icon>
      </button>

      <div class="cv-tb-search__panel" *ngIf="isOpen()" role="menu">
        <button type="button" class="cv-tb-search__item" (click)="pick('global', $event)" role="menuitem">
          <lib-canvas-toolbar-icon name="global-search"></lib-canvas-toolbar-icon>
          <span>Global Search</span>
        </button>
        <button type="button" class="cv-tb-search__item" (click)="pick('bbox', $event)" role="menuitem">
          <lib-canvas-toolbar-icon name="bbox-search"></lib-canvas-toolbar-icon>
          <span>B-Box Search</span>
        </button>
      </div>
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
})
export class SearchToolComponent {
  @Output() search = new EventEmitter<CanvasSearchMode>();

  readonly chevronImgClass = 'cv-toolbar-icon-img--chevron';

  readonly isOpen = signal(false);

  constructor(private readonly host: ElementRef<HTMLElement>) {}

  onMainClick(): void {
    this.search.emit('global');
    this.isOpen.set(false);
  }

  toggleMenu(ev: Event): void {
    ev.stopPropagation();
    this.isOpen.update((v) => !v);
  }

  pick(mode: CanvasSearchMode, ev: Event): void {
    ev.stopPropagation();
    this.search.emit(mode);
    this.isOpen.set(false);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(ev: MouseEvent): void {
    if (!this.isOpen()) return;
    const t = ev.target as Node;
    if (!this.host.nativeElement.contains(t)) {
      this.isOpen.set(false);
    }
  }
}
